import { render, staticRenderFns } from "./Form.Adicoes.vue?vue&type=template&id=8dd8108c"
import script from "./Form.Adicoes.vue?vue&type=script&lang=js"
export * from "./Form.Adicoes.vue?vue&type=script&lang=js"
import style0 from "./Form.Adicoes.vue?vue&type=style&index=0&id=8dd8108c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports